/* eslint-disable react/prop-types */
import React from 'react';

import styled from 'react-emotion';
import { Container as SemanticContainer } from 'semantic-ui-react';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';

import {
  ProductDetailsHorizontalSeparator,
  GridArea,
  BottomBorderedGridArea,
} from '~/modules/coreUI/components/layouts/helpers/GridLayout';

const MobileGrid = styled.div`
  display: grid;
  grid-template:
    'header          header             price           price' auto
    '.               slider             slider          actionButtons' auto
    'hRule0          hRule0             hRule0          hRule0' auto
    'vendorDetails   vendorDetails      vendorDetails   vendorDetails' auto
    'rootVariants    rootVariants       rootVariants    rootVariants' auto
    'cartActions     cartActions        cartActions     cartActions' auto
    'mShareButtons   mShareButtons      mShareButtons   mShareButtons' auto
    'tabs            tabs               tabs            tabs' auto
    'reviews         reviews            reviews         reviews' auto
    / 100px 1fr auto 100px;

  grid-column-gap: ${props => 2.5 * props.theme.new.spacer}px;
  grid-row-gap: ${props => props.theme.paddings.normal}px;

  padding-top: ${props => 1.5 * props.theme.new.spacer}px;
`;

const ProductDetailsMobileLayout = (props) => {
  if (props.loader) {
    return props.loader;
  }
  return (
    <SemanticContainer>
      <MobileGrid>
        <GridArea gridArea="header" leftAligned>
          {props.productTitle}
        </GridArea>
        <GridArea gridArea="price" rightAligned leftBordered paddingLeft={3.5}>
          {props.productPrice}
          {props.SellingOptionLink}
        </GridArea>
        <GridArea gridArea="slider">{props.productImageSlider}</GridArea>
        <GridArea gridArea="vendorDetails">
          {props.vendorDetails}
        </GridArea>
        <BottomBorderedGridArea gridArea="rootVariants" leftAligned topJustified>
          {props.options}
          {props.packageVariants}
          {props.packageVariants ? <Spacer size={2.5} /> : null}
          {props.offeredVariants}
          {props.productOffers}
          {props.productSummary}
        </BottomBorderedGridArea>
        {(props.cartActions || props.BuyingOptionsLink || props.SellingOptionLink) && (
          <BottomBorderedGridArea gridArea="cartActions" centerAligned row>
            {props.cartActions}
            {props.BuyingOptionsLink}
          </BottomBorderedGridArea>
        )}
        <GridArea gridArea="actionButtons" rightAligned bottomJustified>
          {props.actionButtons}
        </GridArea>
        <BottomBorderedGridArea gridArea="mShareButtons" leftAligned>
          {props.mobileShareButtons}
        </BottomBorderedGridArea>
        <GridArea gridArea="hRule0" stretchAligned>
          <ProductDetailsHorizontalSeparator />
        </GridArea>
        <GridArea gridArea="tabs" stretchAligned>
          {props.productTabs}
          {props.OfferDescription}
        </GridArea>
        <GridArea gridArea="reviews" stretchAligned>
          <Separator customColorTone="#f9f9f9" separatorLength="full" separatorWeight={1.5} spacerSize={[1.5, 1.5, 2.5]} />
          {props.productReviews}
        </GridArea>
      </MobileGrid>
      {props.relatedProducts}
      <Spacer size={4} />
    </SemanticContainer>
  );
};

export default withMedia(ProductDetailsMobileLayout);
